import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

const colors = {
    'Processing': 'gray',
    'Invalid file': 'red',
    'Finished': 'red',
    'Failed': 'red',
    'Reported Success': 'gray',
    'Reported Error': 'red',
    'Viewer OK': 'green',
    'Não visualizado': 'gray',
    'Visualizado': 'green',
    'Editado': 'green',
    'Aprovado': 'green',
}


export default function StatusBadge({ status }) {
    const { t } = useTranslation();
    const [s1, s2] = status

    function getColor(status) {
        return colors[status];
    }

    function isValidStatus(s) {
        return s && s !== 'Não visualizado'
    }

    return (
        <div className="flex flex-row items-center justify-evenly">
            <span
                className={classnames('text-xs px-2.5 py-0.5 rounded',
                    { 'bg-green-100 text-green-800  dark:bg-green-900 dark:text-green-300': getColor(s1) === 'green' },
                    { 'bg-red-100 text-red-800  dark:bg-red-900 dark:text-red-300': getColor(s1) === 'red' },
                    { 'bg-gray-100 text-gray-800  dark:bg-gray-900 dark:text-gray-300': getColor(s1) === 'gray' },
                    { 'bg-blue-100 text-blue-800  dark:bg-blue-900 dark:text-blue-300': getColor(s1) === 'blue' }
                )}
                title={t(`Common:Status ${s1}`)}
            >
                {s1 ? t(`Common:Status ${s1}`) : ''}
            </span>

            { isValidStatus(s2) && (
                <span
                    className={classnames('text-xs px-2.5 py-0.5 rounded',
                        { 'bg-green-100 text-green-800  dark:bg-green-900 dark:text-green-300': getColor(s2) === 'green' },
                        { 'bg-red-100 text-red-800  dark:bg-red-900 dark:text-red-300': getColor(s2) === 'red' },
                        { 'bg-gray-100 text-gray-800  dark:bg-gray-900 dark:text-gray-300': getColor(s2) === 'gray' },
                        { 'bg-blue-100 text-blue-800  dark:bg-blue-900 dark:text-blue-300': getColor(s2) === 'blue' }
                    )}
                    title={t(`Common:Status ${s2}`)}
                >
                    {t(`Common:Status ${s2}`)}
                </span>
            )}
        </div>
    )
}
